module.exports = __webpack_public_path__ + "static/media/icon-title-alert-close.af2aefe4.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/elements/Alert/assets/icon-title-alert-close.svg
// module id = 1485
// module chunks = 193